// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3WaQm","inner":"Footer_inner__WPBFo","nextIcon":"Footer_nextIcon__3er4N","innerLeft":"Footer_innerLeft__3MnqP"};